import React , {useState} from "react";
import { MdClose } from "../utils/Icons";
import { useOrderProcessingContext } from "../context/OrderProcessingContext";

const CollectionMethodPopup = ({ products }) => {
  const {
    collectionType,
    setCollectionType,
    isCollectionMethodPopup,
    setIsCollectionMethodPopup,
    serviceableArea
  } = useOrderProcessingContext();

  const [isCollection,setIsCollection] = useState(false)

  const radiologyProducts = products
    .filter((product) => product.productType === "Radiology")
    .map((product) => product.productTitle);

  const otherProducts = products
    .filter((product) => product.productType !== "Radiology")
    .map((product) => product.productTitle);

  const handlePopupClose = () => {
    setIsCollectionMethodPopup((prev) => !prev);
  };

  const handleCollectionChange = (e) => {
    setIsCollection(true);
    setCollectionType(e.target.value);
  }

  return (
    <div className="w-screen h-screen bg-black/25 backdrop-blur flex justify-center items-center p-[3%] fixed left-0 top-0 right-0 bottom-0 z-50">
      <div className="w-full lg:w-[50%] h-full lg:h-[75%]  bg-whiteColor flex flex-col justify-start items-center rounded-3xl lg:rounded-3xl p-[3%] lg:p-[1%] relative">
        <div className="w-full h-fit flex justify-end items-center">
          <button
            className="text-[5vw] lg:text-[1.25vw] text-textPrimaryColor"
            onClick={handlePopupClose}
          >
            <MdClose />
          </button>
        </div>
        <div className="flex flex-col items-center w-full h-[80%] overflow-y-scroll">
          <span className="font-semibold text-[5vw] lg:text-[1.25vw] text-textPrimaryColor mb-[1%]">
            Choose Your Test Collection Method
          </span>
          <div className="w-full mt-4 h-fit flex flex-col lg:flex-row lg:justify-between items-start lg:items-center space-y-[2%] lg:space-y-0 px-[5%] mb-[5%] lg:mb-[2%]">
            <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
              For Pathology Test & Packages
            </span>
            <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
              Available Options
            </span>
          </div>
          <div className="w-full h-fit flex flex-col lg:flex-row lg:justify-between items-start lg:items-center space-y-[2%] lg:space-y-0 px-[5%] mb-[5%] lg:mb-[2%]">
            <div className="flex flex-col w-[50%]">
              {otherProducts?.map((item, index) => (
                <p
                  className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
                  key={index}
                >
                  {item}
                </p>
              ))}
            </div>

            <select
              value={serviceableArea.flag ? collectionType : "Visit"}
              onChange={handleCollectionChange}
              className={`${isCollection?'bg-primaryColor text-white':'border border-primaryColor'}  rounded-3xl px-[2%] py-[1%] outline-none`}
            >
              { serviceableArea.flag && (
                <option
                  value="Home"
                  className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor"
                >
                  Home Collection
                </option>
              )}
              <option
                value="Visit"
                className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor"
              >
                Center Visit
              </option>
            </select>
          </div>
          <hr className="border-1 border-gray-200 my-4 w-full space-y-4" />
          <div className="w-full h-fit flex flex-col mt-4 lg:flex-row lg:justify-between items-start lg:items-center space-y-[2%] lg:space-y-0 px-[5%] mb-[5%] lg:mb-[2%]">
            <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
              For Radiology Tests
            </span>
            <span className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
              Available Options
            </span>
          </div>
          <div className="w-full h-fit flex flex-col lg:flex-row lg:justify-between items-start lg:items-center space-y-[2%] lg:space-y-0 px-[5%] mb-[5%] lg:mb-[2%]">
            <div className="flex flex-col w-[50%]">
              {radiologyProducts?.map((item, index) => (
                <p
                  className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
                  key={index}
                >
                  {item}
                </p>
              ))}
            </div>
            <select
              value={"Visit"}
              className="border border-primaryColor rounded-3xl px-[2%] py-[1%] outline-none"
              disabled
            >
              <option
                value="Home"
                className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor"
              >
                Home Collection
              </option>
              <option
                value="Visit"
                className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textPrimaryColor"
              >
                Center Visit
              </option>
            </select>
          </div>
        </div>
        <button
          className="w-[66%] lg:w-[33%] btn-primary absolute bottom-[3%] lg:bottom-[5%]"
          onClick={handlePopupClose}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default CollectionMethodPopup;
